/// <reference path="../../vendor/angular/angular.js" />
/// <reference path="../../vendor/angular-ui/ui-bootstrap-custom-tpls.js" />
'use strict';

angular.module('selfAccessRequestControllers.Arrival', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'services.search',
    'selfAccessRequestSharedControllers']);